import { takeEvery, all, put, call } from "redux-saga/effects"
import { DckActionTypes } from "dck-redux"
import * as ActionTypes from "../actions/types"
import apiServerApi from "./apiServerApi"
import store from "store"

const session = store.get("sessionData")

function* importBatchesFromCSV(action) {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: ActionTypes.BATCHES_IMPORT
  })

  try {
    const response = yield call(
      apiServerApi.importBatchesFromCSV,
      session.access_token,
      action.file
    ),
    success = response.code === 200 && response.body ? true : false
    yield put({
      type: DckActionTypes.ASYNC_PROCESS_STOP,
      processCode: ActionTypes.BATCHES_IMPORT,
      result: { success }
    })
  }
  catch (error) {
    yield put({
      type: DckActionTypes.ASYNC_PROCESS_STOP,
      processCode: ActionTypes.BATCHES_IMPORT,
      result: { success: false }
    })
  }
}

function* importSaga() {
  yield all([takeEvery(ActionTypes.BATCHES_IMPORT, importBatchesFromCSV)])
}

export default importSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/import.js